import { FunctionComponent, useContext } from "react";
import { Text } from "@kanda-libs/ks-design-library";
import LineItemContext from "components/job/LineItem/LineItemContext";

export interface VatProps {}

const Vat: FunctionComponent<VatProps> = () => {
  const { vat = "", classNames } = useContext(LineItemContext);

  return <Text className={classNames.vat} text={vat} />;
};

export default Vat;
